module.exports = __webpack_public_path__ + "media/images/resource_center_ia-14e16b530f9bf4fc1df1ed2377ae3358.gif";